import { Injectable } from '@angular/core';
import { RequestService } from '@core/services/request/request.service';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { MasterSocietyApiModel } from '@core/api/model/master/master-society-api.model';
import { MasterInstallationApiModel } from '@core/api/model/master/master-installation-api.model';
import { HttpParams } from '@angular/common/http';
import { MasterPostalCodeTownsApi } from '@core/api/model/master/master-postal-code-towns-api.model';
import { MasterRoadTypeApi } from '@core/api/model/master/master-road-type-api.model';
import { LoadingIds } from '@shared/constants/loading';
import { MasterSelfAutoconsumptionApi } from '../../model/master/master-self-autoconsumption-api.model';

@Injectable({
  providedIn: 'root',
})
export class ApiMaestrosService {
  constructor(private requestService: RequestService) {}

  downloadDocument(idDCTM: string, hideErrorAlert?: boolean) {
    return this.requestService.download(ApiDirectory.Maestros.DescargarDocumento({ idDCTM }), {
      hideErrorAlert,
    });
  }

  downloadDocumentWithProgress(idDCTM: string) {
    return this.requestService.downloadWithProgress(ApiDirectory.Maestros.DescargarDocumento({ idDCTM }));
  }

  downloadDocumentsWithProgress(idDCTMs: Array<string>) {
    let params = new HttpParams();
    idDCTMs.forEach((code: string) => (params = params.append('idDCTM', code)));
    return this.requestService.downloadWithProgress(ApiDirectory.Maestros.DescargarDocumentos({}), {
      params,
    });
  }

  fetchSocieties(genericLoading?: boolean) {
    return this.requestService.get<RequestResponse<Array<MasterSocietyApiModel>>>(ApiDirectory.Maestros.Sociedades({}), {
      loading: genericLoading ?? LoadingIds.FETCH_MASTER_SOCIETIES,
    });
  }

  fetchInstallations(genericLoading?: boolean) {
    return this.requestService.get<RequestResponse<Array<MasterInstallationApiModel>>>(ApiDirectory.Maestros.Instalaciones({}), {
      loading: genericLoading ?? LoadingIds.FETCH_MASTER_INSTALLATIONS,
    });
  }

  fetchTownByPostalCode(postal: string) {
    return this.requestService.get<RequestResponse<MasterPostalCodeTownsApi>>(
      ApiDirectory.Maestros.PoblacionCodPostal({
        postal,
      }),
      {
        loading: LoadingIds.FETCH_MASTER_TOWNS_POSTAL_CODE,
      }
    );
  }

  fetchRoadTypes() {
    return this.requestService.get<RequestResponse<Array<MasterRoadTypeApi>>>(ApiDirectory.Maestros.TiposVias({}), {
      loading: LoadingIds.FETCH_MASTER_ROAD_TYPES,
    });
  }

  fetchSelfConsumptions() {
    return this.requestService.get<RequestResponse<Array<MasterSelfAutoconsumptionApi>>>(ApiDirectory.Maestros.AutoConcumos({}), {
      loading: LoadingIds.FETCH_MASTER_SELF_CONSUMPTIONS,
    });
  }

  fetchCups() {
    return this.requestService.get<RequestResponse<Array<MasterSelfAutoconsumptionApi>>>(ApiDirectory.Maestros.TipoCups({}), {
      loading: LoadingIds.FETCH_MASTER_CUPS,
    });
  }

  fetchSubsectionType() {
    return this.requestService.get<RequestResponse<Array<MasterSelfAutoconsumptionApi>>>(ApiDirectory.Maestros.TipoSubsection({}), {
      loading: LoadingIds.FETCH_MASTER_SUBSECTION_TYPE,
    });
  }

  fetchInstallationType() {
    return this.requestService.get<RequestResponse<Array<MasterSelfAutoconsumptionApi>>>(ApiDirectory.Maestros.TipoInstalacion({}), {
      loading: LoadingIds.FETCH_MASTER_INSTALLATION_TYPE,
    });
  }
}
